module.exports = __webpack_public_path__ + "img/role_6.837808d2.png";